import React from 'react'
import { AttachmentData } from '../../../../../../@types/types'
import MultimediaLink from './MultimediaLink'

export type MultimediaLinksListProps = {
  linksAttachments: AttachmentData[]
  onClick: (id?: string) => void
}

const MultimediaLinksList: React.FC<MultimediaLinksListProps> = ({ linksAttachments, onClick }) =>
  linksAttachments.length > 0 ? (
    <ol className='list-spacing-s'>
      {linksAttachments.map((link) => (
        <MultimediaLink
          key={link.attachment?.id}
          id={link.attachment?.id}
          title={link.attachment?.title}
          linkUrl={link.attachment?.linkUrl}
          onClick={onClick}
        />
      ))}
    </ol>
  ) : (
    <></>
  )

export default MultimediaLinksList
